import { CheckCircle } from "@untitledui/icons"

import { FeaturedIcon } from "@/components/ui/featured-icon"
import type { Brief } from "@/types"

import { ShareLinkChip } from "./share-link-chip"

interface CollabCompletePanelProps {
  participationState: Brief["participation_state"]
  canonicalUrl: string
}

// Replaces the card + form inside the composer section once every slot is
// chosen, so the `#track-prompts` anchor still lands somewhere that
// explains itself.
export function CollabCompletePanel({
  participationState,
  canonicalUrl,
}: CollabCompletePanelProps) {
  return (
    <div className="flex flex-col items-center gap-4 py-6 text-center">
      <FeaturedIcon
        icon={CheckCircle}
        color="success"
        theme="light"
        size="lg"
      />
      <p className="text-primary text-md max-w-md font-medium">
        {participationState.message}
      </p>
      <div className="w-full max-w-md text-left">
        <ShareLinkChip url={canonicalUrl} />
      </div>
    </div>
  )
}
